<template>
    <div>
        <template v-if="Object.values(variantMerchants).length">
            <template v-for="(merchant, merchantId) in variantMerchants">
                <div
                    @click="selectMerchant(merchantId, $event)"
                    :key="'offer-' + merchantId"
                    class="merchant-offer primary-transparent-1">
                    <v-layout row wrap class="ma-0">
                        <v-flex xs12 class="pa-0 merchant-offer-row merchant-offer-price">
                            <div class="pa-2">
                                <product-price
                                    class="d-inline-block font-weight-bold"
                                    v-if="showPrice"
                                    :price="getMerchantPriceData(merchant).price"
                                    :price-data="getMerchantPriceData(merchant)"
                                />

                                <a class="black--text font-weight-bold" @click.stop="onShowFeesInfo(merchant)">
                                    {{ 'inkl.' | translation }}
                                    <span class="text-underline">{{ 'MwSt' | translation }}</span>
                                </a>
                            </div>
                        </v-flex>


                        <v-flex v-if="productIsBuyable" xs12 class="pb-0 merchant-offer-row">
                            <p class="ma-0">
                                <v-icon class="mr-1" color="black" size="20">local_shipping</v-icon>
                                <strong>{{ 'delivery time' | translation }}</strong>
                            </p>
                            <p class="ma-0">
                                {{ 'Delivery time parcel' | translation }}
                            </p>
                            <p class="ma-0">
                                {{ 'Delivery time haulage' | translation }}
                            </p>
                        </v-flex>
                        <product-free-shipping-info
                            v-if="productIsBuyable"
                            :merchant="merchant"
                            :merchantId="parseInt(merchantId)"
                            :merchantTotal="getMerchantPriceData(merchant).price"
                        />

                        <v-flex xs12 class="pt-0 shipping-costs-button merchant-offer-row">
                            <a class="black--text" @click.stop="$root.showShippingModal = true">
                                <v-icon class="mr-1" color="black" size="20">info</v-icon>

                                <strong><span class="text-underline">{{ 'Shipping' | translation }}</span></strong>
                            </a>
                        </v-flex>


                        <v-flex
                            xs12
                            class="pt-0 shipping-costs-button merchant-offer-row"
                            v-if="productIsBuyable"
                        >
                            <span class="font-weight-bold green--text"> {{ 'Product available' | translation }}</span>
                        </v-flex>

                      <v-flex
                          xs12
                          class="pt-0 shipping-costs-button merchant-offer-row"
                          v-if="!productIsBuyable"
                      >
                        <span class="font-weight-bold red--text">{{ 'Product currently unavailable' | translation }}</span>
                      </v-flex>

                    </v-layout>
                </div>

                <google-analytics
                    :trackingCode="merchant.data.attributes['merchant_google_analytics_tracker']"
                    :analyticsCode="merchant.data.attributes['merchant_google_analytics']"
                    :uniqueParam="currentProductId"
                    :key="'ga-' + merchantId"
                />
            </template>
        </template>

        <template v-else>
            <p class="mt-2">{{ 'Unfortunately, there are no offers for this variant.' | translation }}</p>
            <div class="pb-5"></div>
        </template>

        <fees-modal
            modal-id="fees-modal"
            :merchantID="parseInt(activeMerchant)"
            v-model="showFeesModal"
        />
    </div>
</template>

<style scoped lang="stylus">
.merchant-offer-price:after {
    display: block;
    content: '';
    width: 100%;
    height: 1px;
    background: var(--v-primary-base);
    opacity: 30%;
}
</style>

<script>
import AverageRating from '@breakmedia/prime-vue-product/src/product-page/AverageRating';
import GoogleAnalytics from '@breakmedia/prime-vue-product/src/product-page/GoogleAnalytics';
import FeesModal from './FeesModal';

import {createNamespacedHelpers} from 'vuex';
import ProductFreeShippingInfo from "@/components/product/ProductFreeShippingInfo";

const parentModuleName = 'Product';
const { mapState, mapGetters, mapActions, mapMutations } = createNamespacedHelpers(parentModuleName);

export default {
    name: 'MerchantsOffers',
    components: {
        ProductFreeShippingInfo,
        AverageRating,
        GoogleAnalytics,
        FeesModal,
    },
    props: {
        merchants: {},
        displayShippingEstimation: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            showFeesModal: false,
            currentMerchant: null,
            showShippingType: null,
        };
    },
    created() {
        this.loadShippingEstimations();
    },
    computed: {
        ...mapState({
            activeMerchant: state => state.currentMerchantId,
            currentProductId: state => state.currentProductId,
            currentLinkMerchant: state => state.currentLinkMerchant,
            shippingEstimation: state => state.shippingEstimationDates,
            product: state => state.product,
        }),
        ...mapGetters(['isProductBuyable']),
        variantMerchants() {
            let variantMerchants = {};
            if (this.merchants && this.currentProductId) {
                for (const merchantId of Object.keys(this.merchants)) {
                    let merchantData = this.merchants[merchantId];
                    if (merchantData && merchantData.price && merchantData.price[this.currentProductId]) {
                        if (this.currentLinkMerchant && merchantId == this.currentLinkMerchant) {
                            variantMerchants[merchantId] = merchantData;
                        } else if (!this.currentLinkMerchant) {
                            variantMerchants[merchantId] = merchantData;
                        }
                    }
                }
            }

            if (
                Object.values(variantMerchants).length == 1 &&
                Object.keys(variantMerchants)[0] != this.activeMerchant
            ) {
                this.selectMerchant(Object.keys(variantMerchants)[0]);
            }

            return variantMerchants;
        },
        shippingDelayDates() {
            const shippingDelayDates = {};
            Object.values(this.merchants).forEach(merchant => {
                let date = merchant.productAttributes[this.currentProductId].shipping_delay_date;
                if (date === null) {
                    date = merchant.data.attributes.shipping_delay_date;
                }
                Object.assign(shippingDelayDates, {[merchant.id]: date});
            });
            return shippingDelayDates;
        },
        shippingDates() {
            let result = null;
            if (this.shippingEstimation && this.shippingEstimation[this.currentProductId]) {
                result = this.shippingEstimation[this.currentProductId].estimation;
            }

            return result;
        },
        pickupDates() {
            let result = null;
            if (this.shippingEstimation && this.shippingEstimation[this.currentProductId]) {
                result = this.shippingEstimation[this.currentProductId].pickup;
            }

            return result;
        },
        showPrice: () => true, //overwritten in the scoped templates
        productIsBuyable() {
            return this.isProductBuyable(this.product, this.activeMerchant, this.currentProductId);
        },
    },
    methods: {
        ...mapMutations(['setCurrentMerchantId']),
        ...mapActions(['loadShippingEstimationDates']),
        selectMerchant(merchantId, event) {
            if (
                this.$refs['ShippingLink' + merchantId] &&
                this.$refs['ShippingLink' + merchantId].length > 0 &&
                event &&
                event.target
            ) {
                if (this.$refs['ShippingLink' + merchantId][0] == event.target) {
                    return;
                }
            }
            this.setCurrentMerchantId(merchantId);
        },
        isMerchantActive(merchantId) {
            return merchantId == this.activeMerchant;
        },
        loadShippingEstimations() {
            if (this.currentProductId) {
                this.loadShippingEstimationDates({
                    item: this.currentProductId,
                    merchantIds: Object.keys(this.variantMerchants)
                });
            }
        },
        getMerchantPriceData(merchant) {
            return merchant.price[this.currentProductId] ?
                merchant.price[this.currentProductId] :
                {};
        },
        onShowFeesInfo(merchant) {
            this.currentMerchant = merchant;
            this.showFeesModal = true;
        },
        productPrice() {
            let productPrice = 0;
            let obj2 = this.merchants;
            for (var key1 in obj2) {
                let obj = obj2[key1].price;
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) {
                        var val = obj[key];
                        // use val
                        productPrice = val.price;
                    }
                }
            }
            return productPrice;
        },
    },
    watch: {
        currentProductId() {
            this.setCurrentMerchantId(null);
        },
    }
};
</script>
